import { Text } from '@servicetitan/anvil2';
import { customCell } from '@components/table/customCell';
import { BodyText, Icon, TableCellProps } from '@servicetitan/design-system';
import { FC, Fragment } from 'react';
import { Tooltip } from '@components/Tooltip';
import styles from './NameCell.module.css';

export const NameCell: FC<TableCellProps> = customCell((props) => {
  const { dataItem } = props;
  const { name, tooltip } = dataItem;

  const Container = tooltip
    ? ({ children }: { children: React.ReactNode }) => (
        <div className={styles.tooltipContainer}>{children}</div>
      )
    : Fragment;

  return name ? (
    <Container>
      <BodyText size='medium' className={styles.name}>
        {name}
      </BodyText>
      {tooltip && (
        <Tooltip placement='top-start' text={tooltip}>
          <Icon name='info' size='16' />
        </Tooltip>
      )}
    </Container>
  ) : (
    <Text size='small'></Text>
  );
});
